// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  width: 280px;
  height: 100vh;
  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 100;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.3);
}

.sidebar-content {
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.sidebar-section {
  padding: 0 20px;
  margin-bottom: 24px;
}

.sidebar-section-title {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0 0 12px 0;
  padding: 0;
}

/* Navigation */
.sidebar-nav {
  padding: 0 20px;
  margin-bottom: 24px;
}

.sidebar-nav-link {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  margin-bottom: 4px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  border-radius: 6px;
  transition: all 0.2s ease;
  font-size: 0.9rem;
}

.sidebar-nav-link:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  transform: translateX(2px);
}

.sidebar-nav-link.active {
  background: linear-gradient(90deg, rgba(66, 153, 225, 0.3) 0%, rgba(66, 153, 225, 0.1) 100%);
  color: #4299e1;
  border-left: 3px solid #4299e1;
  font-weight: 500;
}

.sidebar-icon {
  margin-right: 10px;
  font-size: 1.1rem;
  width: 20px;
  text-align: center;
}

/* Portfolio Stats */
.sidebar-stat {
  margin-bottom: 16px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.sidebar-stat-label {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.sidebar-stat-value {
  font-size: 1.1rem;
  font-weight: 600;
  color: #fff;
  margin-bottom: 4px;
}

.sidebar-stat-value.positive {
  color: #48bb78;
}

.sidebar-stat-value.negative {
  color: #f56565;
}

.sidebar-stat-change {
  font-size: 0.8rem;
  font-weight: 500;
}

.sidebar-stat-change.positive {
  color: #48bb78;
}

.sidebar-stat-change.negative {
  color: #f56565;
}

/* Goals */
.sidebar-goal {
  margin-bottom: 16px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.sidebar-goal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.sidebar-goal-label {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}

.sidebar-goal-status {
  font-size: 0.9rem;
  font-weight: 600;
}

.sidebar-goal-status.on-track {
  color: #48bb78;
}

.sidebar-goal-status.behind {
  color: #f56565;
}

.sidebar-goal-progress {
  margin-bottom: 8px;
}

.sidebar-goal-progress-bar {
  width: 100%;
  height: 6px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
  overflow: hidden;
}

.sidebar-goal-progress-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.3s ease;
}

.sidebar-goal-progress-fill.on-track {
  background: linear-gradient(90deg, #48bb78 0%, #38a169 100%);
}

.sidebar-goal-progress-fill.behind {
  background: linear-gradient(90deg, #f56565 0%, #e53e3e 100%);
}

.sidebar-goal-amount {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
}

.sidebar-goal-link {
  display: block;
  text-align: center;
  padding: 8px;
  color: #4299e1;
  text-decoration: none;
  font-size: 0.85rem;
  border-radius: 6px;
  transition: all 0.2s ease;
  margin-top: 8px;
}

.sidebar-goal-link:hover {
  background: rgba(66, 153, 225, 0.1);
  color: #63b3ed;
}

/* User Info */
.sidebar-section-footer {
  margin-top: auto;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.sidebar-user-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sidebar-user-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: #fff;
  margin-bottom: 4px;
}

.sidebar-settings-link {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
}

.sidebar-settings-link:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

/* Loading */
.sidebar-loading {
  padding: 12px;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.85rem;
}

/* Scrollbar Styling */
.sidebar::-webkit-scrollbar {
  width: 6px;
}

.sidebar::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
}

.sidebar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.sidebar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .sidebar {
    width: 260px;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
  }

  .sidebar.open {
    transform: translateX(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,gDAAgD;EAChD,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,4FAA4F;EAC5F,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".sidebar {\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 280px;\n  height: 100vh;\n  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  overflow-y: auto;\n  overflow-x: hidden;\n  z-index: 100;\n  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.3);\n}\n\n.sidebar-content {\n  padding: 20px 0;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.sidebar-section {\n  padding: 0 20px;\n  margin-bottom: 24px;\n}\n\n.sidebar-section-title {\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: rgba(255, 255, 255, 0.6);\n  margin: 0 0 12px 0;\n  padding: 0;\n}\n\n/* Navigation */\n.sidebar-nav {\n  padding: 0 20px;\n  margin-bottom: 24px;\n}\n\n.sidebar-nav-link {\n  display: flex;\n  align-items: center;\n  padding: 10px 12px;\n  margin-bottom: 4px;\n  color: rgba(255, 255, 255, 0.8);\n  text-decoration: none;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  font-size: 0.9rem;\n}\n\n.sidebar-nav-link:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  transform: translateX(2px);\n}\n\n.sidebar-nav-link.active {\n  background: linear-gradient(90deg, rgba(66, 153, 225, 0.3) 0%, rgba(66, 153, 225, 0.1) 100%);\n  color: #4299e1;\n  border-left: 3px solid #4299e1;\n  font-weight: 500;\n}\n\n.sidebar-icon {\n  margin-right: 10px;\n  font-size: 1.1rem;\n  width: 20px;\n  text-align: center;\n}\n\n/* Portfolio Stats */\n.sidebar-stat {\n  margin-bottom: 16px;\n  padding: 12px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.sidebar-stat-label {\n  font-size: 0.75rem;\n  color: rgba(255, 255, 255, 0.6);\n  margin-bottom: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.sidebar-stat-value {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #fff;\n  margin-bottom: 4px;\n}\n\n.sidebar-stat-value.positive {\n  color: #48bb78;\n}\n\n.sidebar-stat-value.negative {\n  color: #f56565;\n}\n\n.sidebar-stat-change {\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.sidebar-stat-change.positive {\n  color: #48bb78;\n}\n\n.sidebar-stat-change.negative {\n  color: #f56565;\n}\n\n/* Goals */\n.sidebar-goal {\n  margin-bottom: 16px;\n  padding: 12px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.sidebar-goal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.sidebar-goal-label {\n  font-size: 0.75rem;\n  color: rgba(255, 255, 255, 0.6);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n}\n\n.sidebar-goal-status {\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.sidebar-goal-status.on-track {\n  color: #48bb78;\n}\n\n.sidebar-goal-status.behind {\n  color: #f56565;\n}\n\n.sidebar-goal-progress {\n  margin-bottom: 8px;\n}\n\n.sidebar-goal-progress-bar {\n  width: 100%;\n  height: 6px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.sidebar-goal-progress-fill {\n  height: 100%;\n  border-radius: 3px;\n  transition: width 0.3s ease;\n}\n\n.sidebar-goal-progress-fill.on-track {\n  background: linear-gradient(90deg, #48bb78 0%, #38a169 100%);\n}\n\n.sidebar-goal-progress-fill.behind {\n  background: linear-gradient(90deg, #f56565 0%, #e53e3e 100%);\n}\n\n.sidebar-goal-amount {\n  font-size: 0.85rem;\n  color: rgba(255, 255, 255, 0.8);\n  font-weight: 500;\n}\n\n.sidebar-goal-link {\n  display: block;\n  text-align: center;\n  padding: 8px;\n  color: #4299e1;\n  text-decoration: none;\n  font-size: 0.85rem;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  margin-top: 8px;\n}\n\n.sidebar-goal-link:hover {\n  background: rgba(66, 153, 225, 0.1);\n  color: #63b3ed;\n}\n\n/* User Info */\n.sidebar-section-footer {\n  margin-top: auto;\n  padding-top: 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.sidebar-user-info {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.sidebar-user-name {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #fff;\n  margin-bottom: 4px;\n}\n\n.sidebar-settings-link {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 6px;\n  color: rgba(255, 255, 255, 0.8);\n  text-decoration: none;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 100%;\n}\n\n.sidebar-settings-link:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n/* Loading */\n.sidebar-loading {\n  padding: 12px;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 0.85rem;\n}\n\n/* Scrollbar Styling */\n.sidebar::-webkit-scrollbar {\n  width: 6px;\n}\n\n.sidebar::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.sidebar::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 3px;\n}\n\n.sidebar::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .sidebar {\n    width: 260px;\n    transform: translateX(-100%);\n    transition: transform 0.3s ease;\n  }\n\n  .sidebar.open {\n    transform: translateX(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
